module.exports = __webpack_public_path__ + "media/images/icon-angry-73d7db8fd946d7102e41973328660d40.svg";